var React = require('react');

function EmailChat (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"45","cy":"45","r":"44","stroke":"#CE445B","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M55.3684 29.4211L53.2842 31.5053M45.0526 25V27.9474M34.7368 29.4211L36.8189 31.5053M28.2105 56.5789V43.9474C28.2105 42.2723 28.8759 40.6659 30.0604 39.4814C31.2448 38.297 32.8513 37.6316 34.5263 37.6316H55.5789C57.254 37.6316 58.8604 38.297 60.0449 39.4814C61.2293 40.6659 61.8947 42.2723 61.8947 43.9474V56.5789M53.4737 46.0579L47.1613 49.6997C46.5215 50.0688 45.7958 50.2631 45.0572 50.2631C44.3185 50.2631 43.5929 50.0688 42.9531 49.6997L36.6316 46.0526M66.1053 65H24","stroke":"#CE445B","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

EmailChat.defaultProps = {"width":"90","height":"90","viewBox":"0 0 90 90","fill":"none"};

module.exports = EmailChat;

EmailChat.default = EmailChat;
